import React, { Component } from 'react';
import classNames from 'classnames';
import { get } from 'lodash';
import { Carousel } from 'react-responsive-carousel';

const BigLogoStyle = {
  background: 'transparent url(https://www.paypalobjects.com/webstatic/i/logo/rebrand/ppcom-white.svg) center center no-repeat',
  backgroundSize: '124px 33px',
  position: 'absolute',
  bottom: '0px',
  width: '136px',
  height: '43px',
};

export class Carousal extends Component {
  constructor(props) {
    super(props);
    const videos = get(this.props, 'carouselContent.carousel', []).map(item => item.videoUrl);
    this.state = {
      videos
    };
    this.play = this.play.bind(this);
    this.stop = this.stop.bind(this);
  }

  play() {
    const src = this.state.videos[this.props.videoIndex];

    this.refs.video.setAttribute('src', src);
    this.refs.video.load();
    this.refs.video.play();
  }

  stop() {
    if (!this.refs.video.paused) {
      this.refs.video.pause();
    }
  }

  render() {
    let campaignCarousel = this.props.carouselContent;
    let fallbackbgImage = campaignCarousel && campaignCarousel.bgImage ?
      campaignCarousel.bgImage :
      '';
    let carouselArray = campaignCarousel.carousel;

    let showIndicators = carouselArray.length !== 1;

    let playVideoFullScreen = classNames('fullScreenVideo', {
      playVideo: this.props.playVideo,
    });

    let { playVideo, stopVideo } = this.props;

    if (playVideo) {
      this.play();
    }

    if (stopVideo) {
      this.stop();
    }

    let carouselImages = carouselArray.map((response, index) => {
      return (
        <div
          key={index}
          className={'carouselImage'}
          style={{
            background: 'linear-gradient(rgba(0,0,0,0.12), rgba(0,0,0,0.11)), url(' +
              response.imgUrl +
              ') no-repeat',
            backgroundSize: 'cover',
            position: 'relative',
            backgroundPosition: 'center center',
            width: '100%',
          }}
        >
          {
            response.videoUrl ?
              (<div
                onClick={this.props.renderPlay.bind(null, index)}
                className={'playPause'}/>) :
              null
          }
        </div>
      );
    });

    let carouselVideos = (
      <div className={playVideoFullScreen}>
        <span
          onClick={this.props.closeVideoPlay.bind(null, undefined)}
          className={'icon icon-small icon-close-small closeIcon'}
        />
        <div className={'videoContainer'}>
          <div className={'videoContainerChild col-sm-12'}>
            <video ref={'video'} className={'videoStyling'} controls>
              <source src={''} />
            </video>
          </div>
        </div>
      </div>
    );

    return (
      <div>
        {carouselVideos}
        <div
          className={'mainHeroImage'}
          style={{
            background: 'linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.15)), url(' +
              fallbackbgImage +
              ') no-repeat',
            backgroundSize: 'cover',
            position: 'relative',
            backgroundPosition: 'center center',
          }}
        >
          {
            <div className={'innerHeroContainer'}>
              <div className={'carouselContainer'}>
                <Carousel
                  autoPlay={true}
                  onChange={this.handleCarouselChange}
                  showArrows={true}
                  showStatus={false}
                  showThumbs={false}
                  showIndicators={showIndicators}
                  infiniteLoop={true}
                  onClickItem={this.onClickItem}
                  swipeScrollTolerance={5}
                  stopOnHover={true}
                >
                  {carouselImages}
                </Carousel>
              </div>
            </div>}
        </div>
      </div>
    );
  }
}

export default Carousal;
